import { getallpartner, addPartner, updatePartner, create_UpdatePartner } from "../../../services/partner/partner";
import {
  getallcustomer,
  addCustomer,
  updateCustomer,
  disableCustomer,
  fetchShipTos,
  addShipTo,
  updateShipTo,
  deleteShipTo,
} from "../../../services/customer/customer";
import {
  getallsupplier,
  addSupplier,
  updateSupplier,
  disableSupplier,
  fetchShipFroms,
  addShipFrom,
  updateShipFrom,
  deleteShipFrom,
} from "../../../services/supplier/supplier";

/**
 * Entity descriptors for the shared Partner Management screens.
 *
 * Customer and Supplier use the storer APIs (`/customer-group`, `/supplier`).
 * Ship To belongs to a customer. Ship From belongs to a supplier.
 * Partner keeps its own field set and endpoints.
 */

export const STORER_LIST_FIELDS = [
  "partner_id",
  "partner_name",
  "partner_email",
  "partner_mobile",
  "address.partner_city",
  "address.partner_state",
  "address.partner_pincode",
  "status",
];

export const PARTNER_ENTITY = {
  key: "partner",
  label: "Partner",
  screenTitle: "Partner Management",
  tableId: "partner-table",
  exportImportPath: "partner",
  sampleFileUrl: "/samples/partner.xlsx",
  sampleFileName: "partner",
  api: {
    list: getallpartner,
    create: addPartner,
    update: updatePartner,
    /** Used when a "Pending" record is moved to Active (creates the external login). */
    activate: create_UpdatePartner,
  },
  /** Address line 2 and contact number are optional. Registration documents are not validated. */
  optionalFieldNames: ["partner_address2", "partner_mobile"],
  addressRequiredFields: ["address1", "city", "pincode", "state", "country"],
};

/**
 * Customer / Supplier create matches the partner screen.
 * Login, terms, bank, and modules are collected with the address.
 * Number of user licenses is not part of either module.
 * Operational hours stay on the supplier form. Customer hours are captured on Ship To.
 */
const STORER_FORM = {
  formVariant: "storer",
  storerApi: true,
  hiddenFieldNames: ["partner_type", "partner_noOfUserLicenses"],
  hideSections: [],
  hideDocuments: false,
  hideOperationalHours: false,
  hideTerms: false,
  optionalFieldNames: ["partner_address2", "partner_postCode"],
  addressRequiredFields: ["address1", "city", "state", "pincode", "country"],
  listFields: STORER_LIST_FIELDS,
};

export const CUSTOMER_ENTITY = {
  key: "customer",
  label: "Customer",
  screenTitle: "Customer Management",
  tableId: "customer-table",
  exportImportPath: "customer",
  sampleFileUrl: "/samples/customer.xlsx",
  sampleFileName: "customer",
  fieldPrefix: "customer",
  api: {
    list: getallcustomer,
    create: addCustomer,
    update: updateCustomer,
    disable: disableCustomer,
  },
  ship: {
    title: "Ship To",
    prefix: "shipto",
    parentIdField: "customerId",
    list: fetchShipTos,
    create: addShipTo,
    update: updateShipTo,
    remove: deleteShipTo,
  },
  ...STORER_FORM,
  hideOperationalHours: true,
};

export const SUPPLIER_ENTITY = {
  key: "supplier",
  label: "Supplier",
  screenTitle: "Supplier Management",
  tableId: "supplier-table",
  exportImportPath: "supplier",
  sampleFileUrl: "/samples/supplier.xlsx",
  sampleFileName: "supplier",
  fieldPrefix: "supplier",
  api: {
    list: getallsupplier,
    create: addSupplier,
    update: updateSupplier,
    disable: disableSupplier,
  },
  ship: {
    title: "Ship From",
    prefix: "shipfrom",
    parentIdField: "supplierId",
    list: fetchShipFroms,
    create: addShipFrom,
    update: updateShipFrom,
    remove: deleteShipFrom,
  },
  ...STORER_FORM,
};

/**
 * Swap the word "Partner" in UI copy (labels, column headers) for the entity label,
 * preserving case: "Partner Name" → "Customer Name", "partner" → "customer".
 */
export const applyEntityLabel = (text, label = "Partner") => {
  if (!text || label === "Partner") return text;
  return String(text)
    .replace(/\bPartner\b/g, label)
    .replace(/\bpartner\b/g, label.toLowerCase());
};
